import { Directive, Output, EventEmitter, ElementRef, HostListener, inject } from '@angular/core';

@Directive({
    selector: '[appOutsideClick]',
    standalone: false
})
export class OutsideClickDirective {
    private elementRef = inject(ElementRef);

    @Output() appOutsideClick = new EventEmitter<void>();

    @HostListener('document:click', ['$event.target'])
    onClick(target: EventTarget | null): void {
        const clickedInside = this.elementRef.nativeElement.contains(target);

        if (!clickedInside) {
            this.appOutsideClick.emit();
        }
    }
}
